import { render } from "./TurnstileCaptcha.vue?vue&type=template&id=cd656398&scoped=true"
import script from "./TurnstileCaptcha.vue?vue&type=script&lang=js"
export * from "./TurnstileCaptcha.vue?vue&type=script&lang=js"

import "./TurnstileCaptcha.vue?vue&type=style&index=0&id=cd656398&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd656398"]])

export default __exports__